type AppEnv = "development" | "staging" | "production";

interface EnvConfig {
  apiBaseUrl: string;
  appEnv: AppEnv;
  appName: string;
  isDevelopment: boolean;
  isStaging: boolean;
  isProduction: boolean;
}

const REQUIRED: Array<keyof ImportMetaEnv> = [
  "VITE_API_BASE_URL",
  "VITE_APP_ENV",
  "VITE_APP_NAME",
];

const validate = (): EnvConfig => {
  for (const key of REQUIRED) {
    if (!import.meta.env[key]) {
      throw new Error(
        `[env] Missing required environment variable: ${key}\n` +
          `Make sure .env.${import.meta.env.MODE} is configured correctly.\n` +
          `See .env.example for reference.`,
      );
    }
  }

  const appEnv = import.meta.env.VITE_APP_ENV as AppEnv;

  return {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
    appEnv,
    appName: import.meta.env.VITE_APP_NAME,
    isDevelopment: appEnv === "development",
    isStaging: appEnv === "staging",
    isProduction: appEnv === "production",
  };
};

export const env = validate();
